import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'NiotaClassicDevicesEditDeviceForm',
  props: {
    editedItem: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    formSaving: {
      type: Boolean,
      required: false,
      default: false
    },
    showStatics: {
      type: Boolean,
      required: false,
      default: false
    },
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    showDeviceType: {
      type: Boolean,
      required: false,
      default: false
    },
    isIotHubManager: {
      type: Boolean,
      required: false,
      default: false
    },
    adrLimits: {
      type: Array,
      required: false,
      default: new Array()
    }
  },
  data: function data() {
    return {
      formItem: null,
      operationalStatus: [{
        value: 0,
        text: this.$i18n_t('NiotaClassic.Devices.form.unset')
      }, {
        value: 1,
        text: this.$i18n_t('NiotaClassic.Devices.form.inTransit')
      }, {
        value: 2,
        text: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation')
      }, {
        value: 3,
        text: this.$i18n_t('NiotaClassic.Devices.form.inOperation')
      }, {
        value: 4,
        text: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive')
      }, {
        value: 5,
        text: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      }],
      timeUnits: [{
        value: 'h',
        text: this.$i18n_t('NiotaClassic.Devices.form.hour')
      }, {
        value: 'd',
        text: this.$i18n_t('NiotaClassic.Devices.form.day')
      }, {
        value: 'w',
        text: this.$i18n_t('NiotaClassic.Devices.form.week')
      }, {
        value: 'm',
        text: this.$i18n_t('NiotaClassic.Devices.form.month')
      }],
      booleanBattery: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    disableField: function disableField() {
      if (!get(this.formItem, 'deviceType.properties.battery_level') || !get(this.formItem, 'deviceType.properties.battery_type') && !this.booleanBattery) {
        return true;
      }

      return false;
    }
  }),
  watch: {
    editedItem: function editedItem() {
      this.initData();
    }
  },
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      this.formItem = cloneDeep(this.editedItem);

      if (!this.formItem.properties) {
        this.formItem['properties'] = {};
      }

      if (!get(this.formItem, 'properties.critical_time_without_package_level')) {
        this.formItem.properties['critical_time_without_package_level'] = {
          time: null,
          unit: {
            text: null,
            value: null
          }
        };
      }

      var batteryType = get(this.formItem, 'deviceType.properties.battery_type');

      if (batteryType === 'Boolean') {
        this.booleanBattery = true;
      }
    },
    filterItems: function filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    updateData: function updateData(item, value) {
      // make sure to truly reset the value if it was un-selected here, otherwise the API will just keep the current value
      this.$emit('updateData', item, value === undefined ? null : value);
    }
  }
};